import { ImgHTMLAttributes } from "react";

type SmartImageProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "loading" | "decoding"> & {
  src: string;
  alt: string;
  width: number;
  height: number;
  /** Priority image (hero/LCP). Disables lazy loading and sets fetchpriority=high. */
  priority?: boolean;
};

/**
 * Centralized <img> wrapper for CLS/LCP hygiene:
 * - forces explicit width/height (reserves box → no layout shift)
 * - lazy loading + async decoding by default
 * - `priority` opts out for the LCP hero image
 * - inline aspect-ratio style guarantees box even before CSS loads
 */
export function SmartImage({
  src,
  alt,
  width,
  height,
  priority = false,
  style,
  ...rest
}: SmartImageProps) {
  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      // @ts-expect-error – valid HTML attribute, React types lag behind
      fetchpriority={priority ? "high" : "auto"}
      style={{ aspectRatio: `${width} / ${height}`, ...style }}
      {...rest}
    />
  );
}

export default SmartImage;